export default __webpack_public_path__ + "static/media/chatapp.66159211.png";